<div class="info-desktop">
  <app-payment-info-message [paymentInfoMessages]="paymentInfoMessages"></app-payment-info-message>
</div>

<app-accordion class="info-mobile">
  <app-accordion-item title="Informacije">
    <div>
      <app-payment-info-message [paymentInfoMessages]="paymentInfoMessages"></app-payment-info-message>
    </div>
  </app-accordion-item>
</app-accordion>